export const loginStatus = {
  AVAILABLE: 'AVAILABLE',
  NOT_LOGGED_IN: 'NOT_LOGGED_IN',
  ON_BREAK: 'ON_BREAK',
  ON_TASK: 'ON_TASK',
  ON_INTERRUPTABLE_TASK: 'ON_INTERRUPTABLE_TASK',
  UNAVAILABLE: 'UNAVAILABLE',
};
